import React, { FunctionComponent, useContext, useState } from 'react'

import { ToastLifecycle } from './constants'
import { Toast, ToastContext, ToastItem } from './Toast'
import { InternalToastOptions, SetToastFn, ToastOptions, ToastProviderProps } from './types'

export const ToastProvider: FunctionComponent<ToastProviderProps> = ({ children, ...otherProps }) => {
  const [toastList, setToastList] = useState<InternalToastOptions[]>([])
  const value = { toastList, setToastList }

  return (
    <ToastContext.Provider value={value}>
      <Toast />
      {children}
    </ToastContext.Provider>
  )
}

export const useToast = (): SetToastFn => {
  const { setToastList } = useContext(ToastContext)

  return (toastOptions: ToastOptions) => {
    const newToast: InternalToastOptions = { ...toastOptions, id: Math.random().toString(36), lifecycle: ToastLifecycle.TRANSITION_IN }
    setToastList((list) => [...list, newToast])
  }
}

export { Toast, ToastContext, ToastItem }

export type { ToastOptions }
